import { api } from "@/lib/apiClient";
import type { WebsiteNewsItem, WebsiteNewsList, WebsiteNewsWebsitePreview } from "@/types/websiteNews";

export type WebsiteNewsData = {
  items: WebsiteNewsItem[];
  websitePreview: WebsiteNewsWebsitePreview;
};

function toWebsiteNewsData(data: WebsiteNewsList): WebsiteNewsData {
  return {
    items: data.items,
    websitePreview: data.website_preview,
  };
}

export async function fetchWebsiteNews(): Promise<WebsiteNewsData> {
  const data = await api.get<WebsiteNewsList>("/api/v1/website-news");
  return toWebsiteNewsData(data);
}

export async function updateWebsiteNews(items: WebsiteNewsItem[]): Promise<WebsiteNewsData> {
  const payload = items.map(({ website_display_status: _status, ...item }) => item);
  const data = await api.put<WebsiteNewsList>("/api/v1/website-news", { items: payload });
  return toWebsiteNewsData(data);
}
